import { render, staticRenderFns } from "./ModalPdf.vue?vue&type=template&id=10c3de30&scoped=true&"
import script from "./ModalPdf.vue?vue&type=script&lang=js&"
export * from "./ModalPdf.vue?vue&type=script&lang=js&"
import style0 from "./ModalPdf.vue?vue&type=style&index=0&id=10c3de30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c3de30",
  null
  
)

export default component.exports